import React from "react";

import { Data } from "components/Graph/util";
import { useDateRange } from "components/WithDateRange";
import QueryPerformanceGraph from "components/QueryPerformanceGraph";

import { useServerGroupPerDatabaseQueryGraphQuery } from "./gql/Query.generated";

function QueryGraph({
  serverGroupId,
  datname,
  className,
}: {
  serverGroupId: string;
  datname: string;
  className?: string;
}) {
  const { from, to } = useDateRange();

  const { data, loading, error } = useServerGroupPerDatabaseQueryGraphQuery({
    variables: {
      serverGroupId,
      datname,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  return (
    <QueryPerformanceGraph
      data={data?.getQueryOverviewStatsForDatabaseGroup as unknown as Data}
      loading={loading}
      error={error}
      className={className}
    />
  );
}

export default QueryGraph;
